import React from "react";
import { Icon, IconButton } from "./";

export function FormError({ message, dismissable }) {
  return (
    <span className="chronos-form-error-text">
      <Icon icon="fas fa-exclamation-triangle fa-fw" />
      &nbsp;{message}
      {dismissable && (
        <span className="chronos-form-error-dismiss">
          <IconButton icon="far fa-close fa-fw" />
        </span>
      )}
    </span>
  );
}
